import type { Event } from "../../reducers/apiTypes";
import { EventImage } from "../common/EventImage";
import {
    formatEventWhenShort,
} from "../../utils/eventDisplay";

type Props = {
    event: Event;
    selected?: boolean;
    onClick?: () => void;
    compact?: boolean;
};

export function SidebarEventItem({
    event,
    selected = false,
    onClick,
    compact = false,
}: Props) {
    const sizeClass = compact ? "size-14" : "size-16";

    return (
        <button
            type="button"
            onClick={onClick}
            className={`flex w-full gap-3 rounded-2xl p-3 text-left transition-colors ${
                selected
                    ? "bg-surface-secondary"
                    : "hover:bg-surface-secondary/60"
            }`}
        >
            <EventImage event={event} className={`shrink-0 rounded-xl ${sizeClass}`} />
            <div className="min-w-0 flex-1">
                <h4 className="truncate text-sm font-semibold text-foreground">
                    {event.name}
                </h4>
                <p className="mt-0.5 text-xs text-muted">
                    {compact
                        ? formatEventWhenShort(event)
                        : `${formatEventWhenShort(event)} · ${event.address?.split(",")[0] ?? ""}`}
                </p>
            </div>
        </button>
    );
}
